import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ThemeProvider } from '@wise/components-theming';
import Types from 'prop-types';
import componentStyles from './TapestryCard.module.less';
export const TapestryCard = ({ children, screenMode = 'light', }) => {
    const derivedStyles = Object.assign({}, componentStyles);
    return (_jsxs("div", Object.assign({ className: derivedStyles.tapestryWrapper }, { children: [_jsx("div", { className: derivedStyles.bgTapestry }), _jsx(ThemeProvider, Object.assign({ theme: "personal", screenMode: screenMode, className: derivedStyles.tapestryCardContent }, { children: children }))] })));
};
TapestryCard.propTypes = {
    children: Types.node.isRequired,
};
export default TapestryCard;
